import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import { Page } from 'ecrion-components';
import { withStyles, createStyles } from '@material-ui/core';
var styles = createStyles({
  link: {
    textDecoration: 'none'
  }
});

var ErrorCloudInstanceMissing =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ErrorCloudInstanceMissing, _React$Component);

  function ErrorCloudInstanceMissing() {
    _classCallCheck(this, ErrorCloudInstanceMissing);

    return _possibleConstructorReturn(this, _getPrototypeOf(ErrorCloudInstanceMissing).apply(this, arguments));
  }

  _createClass(ErrorCloudInstanceMissing, [{
    key: "render",
    value: function render() {
      return React.createElement(Page.Error, {
        hideNavBar: true,
        title: "Unknown Server",
        message: "The app requires an Ecrion cloud instance to function. Looks like it is missing.",
        details: React.createElement(React.Fragment, null, "To provide an Ecrion cloud instance, you need to:", React.createElement("br", null), "- launch the app from the", ' ', React.createElement("a", {
          href: "https://www.ecrion.com",
          className: this.props.classes.link
        }, "Ecrion website", ' '), ' ', "or", React.createElement("br", null), "- launch the app from Ecrion cloud instance", React.createElement("br", null))
      });
    }
  }]);

  return ErrorCloudInstanceMissing;
}(React.Component);

export default withStyles(styles, {
  name: 'ECErrorCloudInstanceMissing'
})(ErrorCloudInstanceMissing);